import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const chorus = defineConnector({
  identifier: "chorus",
  name: "Chorus",
  tagLine: "Conversation intelligence for sales",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://chorus\\.ai/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your Chorus API key",
      items: [
        {
          kind: "markdown",
          content:
            "Chorus is now part of ZoomInfo. Log in to the Chorus dashboard and navigate to **Settings > API** to generate an API key. You’ll need admin access.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://chorus.ai/api/v1/users/me",
  },
});
